<div
  [class]="styleClass"
  [ngClass]="{
    'p-steps p-component': true,
    'p-readonly': readonly,
    'p-steps-doc': !isIndexNumber,
    'p-steps-process': isIndexNumber,
  }"
  [ngStyle]="style">
  <ul data-cy="workflow-stepper" role="tablist">
    @for (item of model; track i; let i = $index) {
      <li
        #menuitem
        class="p-steps-item"
        role="tab"
        [attr.aria-expanded]="i === activeIndex"
        [attr.aria-selected]="i === activeIndex"
        [class]="item.styleClass"
        [ngClass]="{
          'p-highlight p-steps-current': isActive(item, i),
          'p-disabled': item.disabled || (readonly && !isActive(item, i)),
        }"
        [ngStyle]="item.style">
        @if (isIndexNumber) {
          <a
            class="p-menuitem-link"
            [attr.id]="item.id"
            [attr.target]="item.target"
            [href]="item.url || '#'"
            (click)="itemClick($event, item, i)"
            (contextmenu)="showCMChecker(item, i) ? onContextMenu($event) : null">
            <span class="p-steps-number">{{ getDisplayIndex(i) }}</span>
            <span class="p-steps-title">{{ item.label }}</span>
          </a>
        } @else {
          <button
            pButton
            type="button"
            [attr.id]="item.id"
            [attr.target]="item.target"
            [disabled]="readonly"
            label="{{ item.label }}"
            [ngClass]="{ 'p-menuitem-link': true, 'p-button p-button-secondary': !isActive(item, i) }"
            (click)="itemClick($event, item, i)"
            (contextmenu)="showCMChecker(item, i) ? onContextMenu($event) : null"></button>
        }
      </li>
    }
  </ul>
</div>
